import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { usePackage, Package } from './useData';
import { moduleConfig, getDetailSections } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Package>
      useData={usePackage}
      config={{
        ...moduleConfig,
        getDetailSections,
      }}
    />
  );
};

export default Detail;

